import { Injectable, Inject, Injector } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

import { AuthService } from '../auth/auth.service';
import { AppConfigurationService } from '../common/app-configuration.service';
import { EventsManagerService } from '../common/events-manager.service';
import { HttpInterceptor } from '../common/http-interceptor.service';
import { DatabaseService } from '../storage/database.service';
import { ResourceReaderService } from './resource-reader.service';

const DEVICE_REFERENCE = 'device_reference';

@Injectable()
export class DeviceReferenceService extends ResourceReaderService {
  constructor(
    http: HttpInterceptor,
    authService: AuthService,
    databaseService: DatabaseService,
    eventsService: EventsManagerService,
    AppConfiguration: AppConfigurationService,
    injector: Injector
  ) {
    super(
      'devices',
      http,
      authService,
      databaseService,
      eventsService,
      AppConfiguration,
      injector,
      DEVICE_REFERENCE,
      'Device Reference'
    );
  }

  public loadLocalFile(file: any) {
    const obj = JSON.parse(file);
    this.storeLocalVersion(obj);
  }

  public loadFile() {
    this.loadLocalVersion().subscribe((localVersionResponse) => {
      const date = new Date();
      const cacheString =
        '' + date.getUTCDate() + date.getUTCHours() + date.getUTCMinutes();
      this.get('reference', { v: cacheString }).subscribe(
        (referenceResponse) => {
          this.storeLocalVersion(referenceResponse);
        },
        (error) => {
          this._loaded = true;
          this._onLoaded.next(true);
          console.log(
            'Error loading reference file, using local version (' +
            this.version +
            ')'
          );
        }
      );
    });
  }

  protected processData(remoteData: any) {
    this._data = this.resolveGroups(remoteData);
    this._data = this.injectTemplates(remoteData);
  }

  private resolveGroups(data: any): any {
    const groups = data && data.groups;

    if (groups) {
      for (const group of groups) {
        if (group.hasOwnProperty('models') && group.hasOwnProperty('use')) {
          for (const model of group.models) {
            // Do not override model if present
            if (!data.models.hasOwnProperty(model)) {
              data.models[model] = group.use;
              if (group.defaultName) {
                data.models[model].defaultName = group.defaultName;
              }
            }
          }
        }
      }
    }

    return data;
  }

  private injectTemplates(data: any): any {
    const templates = data && data.templates;

    if (templates) {
      const models = data.models;

      if (models) {
        for (const model in models) {
          for (const contextKey in models[model]) {
            const context = models[model][contextKey];
            if (
              context.hasOwnProperty('use') &&
              templates.hasOwnProperty(context.use)
            ) {
              data.models[model][contextKey] = Object.assign(
                context,
                templates[context.use]
              );
            }
          }
        }
      }
    }

    return data;
  }
}
